import React from "react";
import { examinerProfilePoints } from "../mock/mockData";
import { SideIllustration } from "../components/common/SideIllustration";
import { IMAGE_SOURCES } from "../mock/imageSources";

export default function ExaminerPanel() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Examiner Panel</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Examiners are selected for their musical expertise, teaching experience and ability to apply assessment criteria consistently. Global Music Conservatory places particular emphasis on professional integrity and ongoing training.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Selection criteria</h2>
          <ul className="space-y-1">
            {examinerProfilePoints.map((item) => (
              <li key={item}>• {item}</li>
            ))}
          </ul>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.examinerSheet}
          alt="Examiner reviewing sheet music and assessment materials"
        />
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-slate-50/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Training &amp; standardisation</h2>
          <p>
            Examiners participate in initial training and ongoing standardisation activities. Recorded and sample examinations are used to calibrate marking and to ensure that criteria are interpreted consistently across the panel.
          </p>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.examinerNotes}
          alt="Musical notation used during examiner training and standardisation"
        />
      </section>
    </div>
  );
}
